import {Injectable} from '@angular/core';
import {RequestService} from './request.service';
import {ConfigService} from './config.service';

@Injectable()
export class DomainService {

    constructor(private requestService: RequestService, private configService: ConfigService) { }

    getDomainEnabledProductMkp() {
      let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.configuration.domainsEnabledProductMkpLink.api;
      return this.requestService.get(url);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/domain.service.ts